import React, { useEffect, useState, useMemo, useRef } from "react";
import HamBurgerIcon from "../../../Assets/Icons/Group 49.svg";
import profileImagePlaceholderBlue from "../../../Assets/Images/PersonBlue.svg";
import profileImagePlaceholderAdmin from "../../../Assets/Images/Ellipse 3.svg";
import BellIcon from "../../../Assets/Icons/Group 51.svg";
import "./navbar.scss";
import { Dropdown } from "antd";
import { useNavigate } from "react-router-dom";
import SearchBar from "../SearchBar";
import Notifications from "./Notifications";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../services/authService";
import { getFcmToken } from "../../../utils/connectStore";
import Loader from "../Loader";
import debounce from "lodash.debounce";
import { getOffersByMerchant, getNonDraftedOffers } from "../../../services/offerService";
import { getFranchises } from "../../../services/franchiseService";
import { getMerchantBusinessProfile, getMerchants } from "../../../services/merchantService";
import {
  getAllMerchants,
  getBanks,
  getFundraiserProfile,
  getFundraiserReferrals,
  getFundraisers,
  getOnboardingStatus,
} from "../../../services/fundraiserService";
import { getUsers } from "../../../services/adminService";
import { getMerchantInvites } from "../../../services/onboardingService";
// import NotificationPopup from "../NotificationPopup";
import { getS3PublicUrl } from "../../../utils/s3";

const getMerchantIdentity = (merchant) => merchant?._id || merchant?.id;

const getMerchantLogoValue = (merchant) =>
  merchant?.logo ||
  merchant?.logoUrl ||
  merchant?.profileImage ||
  merchant?.user?.logo ||
  merchant?.user?.profileImage ||
  "";

const getMerchantBusinessName = (merchant) =>
  merchant?.businessName ||
  merchant?.business_name ||
  merchant?.merchant?.businessName ||
  merchant?.merchant?.business_name ||
  merchant?.name ||
  "";

const buildSearchResult = ({
  id,
  type,
  title,
  description,
  status,
  action,
}) => ({
  id,
  type,
  title,
  description,
  status,
  action,
});

const Navbar = ({ isSideBarOpen, setisSideBarOpen, element }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isBellClicked, setIsBellClicked] = useState(false);
  const [greeting, setGreeting] = useState("");
  const [navSearchQuery, setNavSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const loading = useSelector((state) => state.authReducer.loading);
  const userData = useSelector((state) => state?.authReducer?.tokenData?.user);
  const selectedMerchant = useSelector((state) => state?.merchantReducer?.selectedMerchent);
  const merchantProfiles = useSelector((state) => state?.merchantReducer?.merchantProfiles?.data);
  const selectedMerchantId = getMerchantIdentity(selectedMerchant);
  const [profileLogoFromApi, setProfileLogoFromApi] = useState(null);
  const [isFundraiserApproved, setIsFundraiserApproved] = useState(false);
  const [isStripeComplete, setIsStripeComplete] = useState(false);

  // Fetch the active merchant profile logo directly from API when selection changes
  useEffect(() => {
    let isActive = true;

    const fetchLogo = async () => {
      // Immediately clear logo when logged out — prevents previous user's logo bleeding through
      if (!userData) {
        if (isActive) setProfileLogoFromApi(null);
        return;
      }
      try {
        const role = (userData?.role || "").toString().toLowerCase();
        if (role === "fundraiser") {
          const res = await getFundraiserProfile();
          if (res?.success && res?.data) {
            // Check Stripe onboarding status
            try {
              const statusPromise = await dispatch(getOnboardingStatus()).unwrap();
              setIsStripeComplete(statusPromise?.data?.detailsSubmitted === true && statusPromise?.data?.chargesEnabled === true);
            } catch (_) { }

            // Guard: only allow approved fundraisers to stay logged in
            const statusRaw = res?.data?.status;
            const status = typeof statusRaw === 'string' ? statusRaw.toLowerCase() : statusRaw;
            const isApproved = status === 'approved' || status === 'live';
            setIsFundraiserApproved(isApproved);

            if (!isApproved) {
              // Force logout and redirect to fundraiser login with message
              let msg = 'Your account is pending admin approval. Please wait for approval.';
              let showPendingModal = true;
              let blockStatus = 'pending';

              if (status === 'disabled') {
                msg = 'Your account is disabled. Please contact support.';
                showPendingModal = false;
                blockStatus = 'disabled';
              } else if (status === 'deleted') {
                msg = 'Your account have been deleted. Please Contact Support';
                showPendingModal = false;
                blockStatus = 'deleted';
              } else if (status === 'rejected') {
                msg = 'Your account has been rejected. Please contact support.';
                blockStatus = 'rejected';
              } else if (status === 'declined') {
                msg = 'Your account has been declined. Please contact support.';
                blockStatus = 'declined';
              }

              sessionStorage.removeItem('showAccountPendingModal');
              sessionStorage.removeItem('fundraiser_stripe_complete');
              sessionStorage.removeItem('fundraiser_verified');
              sessionStorage.setItem('fundraiser_block_status', blockStatus);
              if (showPendingModal) {
                sessionStorage.setItem('showAccountPendingModal', 'true');
              }
              try { await dispatch(logout({ fcmToken: getFcmToken() }))?.unwrap(); } catch (_) { }
              navigate('/fundraiser/account-login', { replace: true, state: { message: msg, showAccountPendingModal: showPendingModal } });
              return;
            }
            if (isActive) setProfileLogoFromApi(res?.data?.logo || res?.data?.profileImage || null);
            return;
          }
        }
        // Skip logo fetch for admin users when they're just selecting merchants for offer creation
        if (role === "admin") {
          if (isActive) setProfileLogoFromApi(null);
          return;
        }
        // Merchant branch
        const targetId =
          selectedMerchantId ||
          userData?.merchantId ||
          userData?.merchant?._id ||
          userData?.merchant?.id;
        if (isActive) setProfileLogoFromApi(null);
        if (targetId) {
          const res = await dispatch(getMerchantBusinessProfile({ id: targetId }))?.unwrap();
          if (isActive && res?.success && res?.data) {
            setProfileLogoFromApi(getMerchantLogoValue(res?.data) || null);
            return;
          }
        }
        if (isActive) setProfileLogoFromApi(null);
      } catch (_) {
        if (isActive) setProfileLogoFromApi(null);
      }
    };
    fetchLogo();

    // Listen for profile update events and refresh logo
    const handleProfileUpdate = () => {
      fetchLogo();
    };
    window.addEventListener('profile-updated', handleProfileUpdate);

    return () => {
      isActive = false;
      window.removeEventListener('profile-updated', handleProfileUpdate);
    };
  // Added `userData` to deps so effect re-runs on login/logout
  }, [dispatch, selectedMerchantId, userData?.merchantId, userData?.role, merchantProfiles, userData, navigate]);
  const userRole = (userData?.role || "").toString().toLowerCase();
  const merchantDisplayName = useMemo(() => {
    if (userRole !== "merchant") return userData?.name || "";

    const selectedBusinessName = getMerchantBusinessName(selectedMerchant);
    if (selectedBusinessName) return selectedBusinessName;

    const matchedProfile = Array.isArray(merchantProfiles)
      ? merchantProfiles.find(
          (profile) => getMerchantIdentity(profile) === getMerchantIdentity(selectedMerchant)
        )
      : null;
    const matchedBusinessName = getMerchantBusinessName(matchedProfile);
    if (matchedBusinessName) return matchedBusinessName;

    return (
      userData?.merchant?.businessName ||
      userData?.merchant?.business_name ||
      userData?.businessName ||
      userData?.business_name ||
      userData?.name ||
      ""
    );
  }, [merchantProfiles, selectedMerchant, userData, userRole]);
  // const unreadCount = useSelector((state) => state?.notificationReducer?.unreadCount);

  const [showBackdrop, setShowBackdrop] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const mobileSearchRef = useRef(null);
  // const [demoNotification, setDemoNotification] = useState(null);

  const handleLogoutClick = async () => {
    // Store the user role before logout since it will be cleared
    const currentUserRole = userRole;

    const logoutPromise = await dispatch(
      logout({ fcmToken: getFcmToken() })
    )?.unwrap();
    if (logoutPromise?.success === true) {
      try {
        localStorage.removeItem('profilePic');
        localStorage.removeItem('LATEST_UPLOADED_LOGO');
        sessionStorage.removeItem('ADMIN_OFFER_CREATION_GUARD');
      } catch (_) { }
      // Navigate to appropriate login page based on user role
      if (currentUserRole && currentUserRole.toLowerCase() === "fundraiser") {
        // If approved and finished Stripe, go to main login page; otherwise dedicated fundraiser login
        if (isFundraiserApproved && isStripeComplete) {
          navigate("/");
        } else {
          navigate("/fundraiser/account-login");
        }
      } else {
        // Navigate cleanly to the login page without query params
        navigate("/");
      }
      // Avoid hard reloads to preserve target route and ensure smooth UX
    }
  };

  const guardedNav = (path) => {
    if (sessionStorage.getItem("ADMIN_OFFER_CREATION_GUARD") === "true") {
      window.dispatchEvent(new CustomEvent("attempt-exit-offer-form", { detail: { path } }));
      return;
    }
    navigate(path);
  };

  const guardedLogout = async () => {
    if (sessionStorage.getItem("ADMIN_OFFER_CREATION_GUARD") === "true") {
      window.dispatchEvent(new CustomEvent("attempt-exit-offer-form", { detail: { action: "logout" } }));
      return;
    }
    await handleLogoutClick();
  };

  const handleMenuClick = ({ key }) => {
    if (key === "profile") {
      guardedNav(`/${userData?.role}/edit-profile`);
    } else if (key === "logout") {
      guardedLogout();
    }
  };

  const menuItems = [
    {
      key: "profile",
      label: <span className="block w-full py-1">Profile Settings</span>,
    },
    {
      key: "logout",
      label: <span className="block w-full py-1">Logout</span>,
    }
  ];

  const onBellClicked = async () => {
    const newState = !isBellClicked;
    setIsBellClicked(newState);

    if (newState) {
      setShowBackdrop(true);
      // Prevent scrolling by fixing the body
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      document.body.style.height = "100vh";
    } else {
      setTimeout(() => {
        setShowBackdrop(false);
      }, 300);
      // Restore scrolling
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      document.body.style.height = "100%";
    }
  };

  const handleBackdropClick = () => {
    // Close notifications when clicking outside
    setIsBellClicked(false);
    setTimeout(() => {
      setShowBackdrop(false);
    }, 300);
  };

  const handleGreeting = () => {
    const now = new Date();
    const hour = now.getHours();

    if (hour < 12) {
      setGreeting("Good Morning");
    } else if (hour < 18) {
      setGreeting("Good Afternoon");
    } else {
      setGreeting("Good Evening");
    }
  };

  useEffect(() => {
    handleGreeting();
  }, []);

  // Search functionality for merchants
  const performSearch = async (query) => {
    if (!query || query.trim().length < 2) {
      setSearchResults([]);
      setShowSearchResults(false);
      return;
    }

    setIsSearching(true);
    setShowSearchResults(true);

    try {
      const results = [];

      if (userRole === "merchant") {
        const [offersResponse, franchisesResponse] = await Promise.allSettled([
          dispatch(
            getOffersByMerchant({
              search: query,
              limit: 5,
              silent: true,
            }),
          ).unwrap(),
          dispatch(
            getFranchises({
              search: query,
              limit: 5,
              silent: true,
            }),
          ).unwrap(),
        ]);

        if (
          offersResponse.status === "fulfilled" &&
          offersResponse.value?.success &&
          Array.isArray(offersResponse.value?.data)
        ) {
          offersResponse.value.data.forEach((offer) => {
            results.push(
              buildSearchResult({
                id: `merchant-offer-${offer?._id}`,
                type: "offer",
                title: offer?.title || "Untitled Offer",
                description: `Offer${offer?.category?.title ? ` • ${offer.category.title}` : ""}`,
                status: offer?.status,
                action: () =>
                  navigate(`/merchant/offer-list`, {
                    state: { openOfferId: offer?._id },
                  }),
              }),
            );
          });
        }

        if (
          franchisesResponse.status === "fulfilled" &&
          franchisesResponse.value?.success &&
          Array.isArray(franchisesResponse.value?.data)
        ) {
          franchisesResponse.value.data.forEach((franchise) => {
            results.push(
              buildSearchResult({
                id: `merchant-store-${franchise?._id}`,
                type: "franchise",
                title:
                  franchise?.name ||
                  franchise?.storeName ||
                  franchise?.locationName ||
                  "Store",
                description: `Store${franchise?.email ? ` • ${franchise.email}` : ""}`,
                status: franchise?.status,
                action: () => navigate(`/merchant/franchise-list`),
              }),
            );
          });
        }
      }

      if (userRole === "admin") {
        const [
          offersResponse,
          merchantsResponse,
          fundraisersResponse,
          usersResponse,
          invitesResponse,
        ] = await Promise.allSettled([
          dispatch(
            getNonDraftedOffers({
              search: query,
              limit: 5,
              silent: true,
            }),
          ).unwrap(),
          dispatch(
            getMerchants({
              search: query,
              limit: 5,
            }),
          ).unwrap(),
          dispatch(
            getFundraisers({
              search: query,
              limit: 5,
            }),
          ).unwrap(),
          dispatch(
            getUsers({
              search: query,
              limit: 5,
            }),
          ).unwrap(),
          dispatch(
            getMerchantInvites({
              search: query,
              limit: 5,
            }),
          ).unwrap(),
        ]);

        if (
          offersResponse.status === "fulfilled" &&
          offersResponse.value?.success &&
          Array.isArray(offersResponse.value?.data)
        ) {
          offersResponse.value.data.forEach((offer) => {
            results.push(
              buildSearchResult({
                id: `admin-offer-${offer?._id}`,
                type: "offer",
                title: offer?.title || "Untitled Offer",
                description: `Offer${offer?.category?.title ? ` • ${offer.category.title}` : ""}`,
                status: offer?.status,
                action: () =>
                  navigate(`/admin/offer-list`, {
                    state: { openOfferId: offer?._id },
                  }),
              }),
            );
          });
        }

        if (
          merchantsResponse.status === "fulfilled" &&
          merchantsResponse.value?.success &&
          Array.isArray(merchantsResponse.value?.data)
        ) {
          merchantsResponse.value.data.forEach((merchant) => {
            results.push(
              buildSearchResult({
                id: `admin-merchant-${merchant?._id}`,
                type: "merchant",
                title:
                  merchant?.businessName ||
                  merchant?.business_name ||
                  merchant?.name ||
                  "Merchant",
                description: `Merchant${merchant?.email ? ` • ${merchant.email}` : ""}`,
                status: merchant?.status,
                action: () =>
                  navigate(`/admin/merchant-list`, {
                    state: { openMerchantId: merchant?._id },
                  }),
              }),
            );
          });
        }

        if (
          fundraisersResponse.status === "fulfilled" &&
          fundraisersResponse.value?.success &&
          Array.isArray(fundraisersResponse.value?.data)
        ) {
          fundraisersResponse.value.data.forEach((fundraiser) => {
            results.push(
              buildSearchResult({
                id: `admin-fundraiser-${fundraiser?._id}`,
                type: "fundraiser",
                title:
                  fundraiser?.fundraiserName ||
                  fundraiser?.organisationName ||
                  fundraiser?.user?.name ||
                  "Fundraiser",
                description: `Fundraiser${
                  fundraiser?.email || fundraiser?.user?.email
                    ? ` • ${fundraiser?.email || fundraiser?.user?.email}`
                    : ""
                }`,
                status: fundraiser?.status,
                action: () =>
                  navigate(`/admin/fundraiser-list`, {
                    state: {
                      openFundraiserId: fundraiser?._id || fundraiser?.id,
                    },
                  }),
              }),
            );
          });
        }

        if (
          usersResponse.status === "fulfilled" &&
          usersResponse.value?.success &&
          Array.isArray(usersResponse.value?.data)
        ) {
          usersResponse.value.data.forEach((user) => {
            results.push(
              buildSearchResult({
                id: `admin-user-${user?._id}`,
                type: "user",
                title: user?.name || user?.fullName || user?.email || "Member",
                description: `Member${user?.email ? ` • ${user.email}` : ""}`,
                status: user?.status || user?.memberStatus,
                action: () =>
                  navigate(`/admin/user-list`, {
                    state: { openUserId: user?._id || user?.id },
                  }),
              }),
            );
          });
        }

        if (
          invitesResponse.status === "fulfilled" &&
          invitesResponse.value?.success &&
          Array.isArray(invitesResponse.value?.data)
        ) {
          invitesResponse.value.data.forEach((invite) => {
            results.push(
              buildSearchResult({
                id: `admin-invite-${invite?._id}`,
                type: "invite",
                title: invite?.email || invite?.businessName || "Invitation",
                description: `Invitation${
                  invite?.businessName ? ` • ${invite.businessName}` : ""
                }`,
                status: invite?.status,
                action: () => navigate(`/admin/invitation-list`),
              }),
            );
          });
        }
      }

      if (userRole === "fundraiser") {
        const [referralsResponse, merchantsResponse, banksResponse] =
          await Promise.allSettled([
            dispatch(
              getFundraiserReferrals({
                search: query,
                limit: 5,
              }),
            ).unwrap(),
            dispatch(
              getAllMerchants({
                search: query,
                limit: 5,
                page: 1,
              }),
            ).unwrap(),
            dispatch(getBanks(query)).unwrap(),
          ]);

        if (
          referralsResponse.status === "fulfilled" &&
          referralsResponse.value?.success &&
          Array.isArray(referralsResponse.value?.data)
        ) {
          referralsResponse.value.data.forEach((referral) => {
            results.push(
              buildSearchResult({
                id: `fundraiser-referral-${referral?._id}`,
                type: "referral",
                title:
                  referral?.businessName ||
                  referral?.merchantName ||
                  referral?.email ||
                  "Referral",
                description: `Referral${referral?.email ? ` • ${referral.email}` : ""}`,
                status: referral?.status,
                action: () => navigate(`/fundraiser/referral-list`),
              }),
            );
          });
        }

        if (
          merchantsResponse.status === "fulfilled" &&
          merchantsResponse.value?.success &&
          Array.isArray(merchantsResponse.value?.data)
        ) {
          merchantsResponse.value.data.forEach((merchant) => {
            results.push(
              buildSearchResult({
                id: `fundraiser-merchant-${merchant?._id}`,
                type: "merchant",
                title:
                  merchant?.businessName ||
                  merchant?.business_name ||
                  merchant?.name ||
                  "Merchant",
                description: `Merchant${merchant?.email ? ` • ${merchant.email}` : ""}`,
                status: merchant?.status,
                action: () => navigate(`/fundraiser/merchant-visibility`),
              }),
            );
          });
        }

        if (
          banksResponse.status === "fulfilled" &&
          banksResponse.value?.success &&
          Array.isArray(banksResponse.value?.data)
        ) {
          banksResponse.value.data.forEach((bank) => {
            results.push(
              buildSearchResult({
                id: `fundraiser-bank-${bank?._id || bank?.id || bank?.name}`,
                type: "bank",
                title: bank?.bankName || bank?.name || "Bank",
                description: `Bank${bank?.accountName ? ` • ${bank.accountName}` : ""}`,
                status: bank?.status,
                action: () => navigate(`/fundraiser/banks-list`),
              }),
            );
          });
        }
      }

      setSearchResults(results.slice(0, 20));
    } catch (error) {
      setSearchResults([]);
    } finally {
      setIsSearching(false);
    }
  };

  // Debounced search
  const debouncedSearch = useMemo(() => {
    const fn = debounce((q) => {
      const trimmed = (q || "").trim();
      if (trimmed.length === 0) {
        setSearchResults([]);
        setShowSearchResults(true);
        setIsSearching(false);
        return;
      }
      performSearch(trimmed);
    }, 350);
    return fn;
  }, [userRole]);

  const handleNavbarSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      const trimmed = (navSearchQuery || "").trim();
      if (trimmed.length === 0) return;
      // If we have results, prefer first result action; otherwise perform a fresh search
      if (searchResults.length > 0) {
        searchResults[0].action?.();
      } else {
        performSearch(trimmed);
      }
      setShowSearchResults(false);
      // keep query so user can refine after navigate; clear if you prefer
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setNavSearchQuery(value);
    debouncedSearch(value);
  };

  const handleSearchResultClick = (result) => {
    result.action();
    setShowSearchResults(false);
    setNavSearchQuery("");
  };

  const handleSearchBlur = () => {
    // Delay hiding results to allow for clicks
    setTimeout(() => {
      setShowSearchResults(false);
    }, 200);
  };

  // Cleanup debounced search on unmount
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  // Ensure sidebar is closed by default on mobile and closes on resize to mobile
  useEffect(() => {
    try {
      if (typeof window !== "undefined") {
        // Close on mount if mobile
        if (window.innerWidth <= 768) {
          setisSideBarOpen(false);
        }
        const handleResize = () => {
          if (window.innerWidth <= 768) {
            setisSideBarOpen(false);
          }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }
    } catch (_) { }
  }, []);

  // Close mobile search when clicking outside
  useEffect(() => {
    if (!mobileSearchOpen) return;
    const onDocClick = (e) => {
      if (mobileSearchRef.current && !mobileSearchRef.current.contains(e.target)) {
        setMobileSearchOpen(false);
      }
    };
    document.addEventListener("click", onDocClick, true);
    return () => document.removeEventListener("click", onDocClick, true);
  }, [mobileSearchOpen]);

  return (
      <div
        id="main-content-area"
        className={
          isSideBarOpen
            ? "main-content-with-sidebar sm:w-[70%] md:w-[75%] lg:w-[80%] xl:w-[80%] overflow-y-auto bg-white relative transition-all duration-300 ease-in-out"
            : "w-full overflow-y-auto bg-white relative transition-all duration-300 ease-in-out"
        }
      >
      {loading && <Loader />}
      <div className={`flex py-4 bg-white items-center justify-between px-4 sm:px-6 shadow-[0px_8px_20px_-12px_rgba(0,0,0,0.35)] relative z-40 ${isSideBarOpen ? "content-seam-shadow" : ""}`}>
        <div className="flex items-center gap-2 md:gap-3">
          <div className="flex-shrink-0">
            <img
              src={HamBurgerIcon}
              className="cursor-pointer w-5 h-5 md:w-auto md:h-auto"
              onClick={() => {
                setisSideBarOpen(!isSideBarOpen);
              }}
              alt="menu"
            ></img>
          </div>
          {(userRole === "admin" || userRole === "fundraiser" || userRole === "merchant") && (
            <div className="flex items-center gap-1 sm:gap-4">
              <button
                type="button"
                aria-label="Search"
                className="sm:hidden p-1 rounded-md flex-shrink-0"
                onClick={() => setMobileSearchOpen(true)}
              >
                {/* Themed search icon - lighter brand color */}
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="#8EDAF5" />
                </svg>
              </button>
              <div className="sm:hidden flex flex-col items-center justify-start relative flex-shrink-0">
                <img
                  src={BellIcon}
                  className="bg-[#00ADEF0D] p-1.5 cursor-pointer w-8 h-8 object-contain"
                  onClick={onBellClicked}
                  alt="notifications"
                />
              </div>
            </div>
          )}
          {(userRole === "admin" || userRole === "fundraiser" || userRole === "merchant") && (
            <div className="relative hidden sm:block w-[200px] sm:w-[280px] md:w-[320px] lg:w-[340px]">
              <SearchBar
                parentDivClass="w-full"
                divClassName="flex items-center w-full h-[40px] relative"
                inputClassName="navSearchBar h-full w-[100%] ps-[4%] pe-[14%] text-[12px] font-[400] outline-none bg-[#F5F5F5] text-[#303030]"
                iconClassName="absolute right-[5%] w-[22px] h-[22px]"
                placeholder="Search here"
                value={navSearchQuery}
                handleChange={handleSearchChange}
                handleKeyDown={handleNavbarSearchKeyDown}
                onBlur={handleSearchBlur}
                onClear={() => {
                  setNavSearchQuery("");
                  setSearchResults([]);
                  setShowSearchResults(false);
                }}
                searchResults={searchResults}
                resultsVisible={showSearchResults}
                noResultsText={isSearching ? "Searching..." : "No results found"}
                handleResultClick={handleSearchResultClick}
                onIconClick={() => {
                  const q = (navSearchQuery || "").trim();
                  if (q.length === 0) {
                    setSearchResults([]);
                    setShowSearchResults(true);
                    return;
                  }
                  performSearch(q);
                }}
              />
            </div>
          )}
        </div>

        <div className="flex items-center justify-end gap-3 sm:gap-4 pr-1 sm:pr-6">
          <div className="hidden sm:flex flex-col items-center justify-start relative flex-shrink-0">
            <img
              src={BellIcon}
              className="bg-[#00ADEF0D] p-1.5 md:p-2 cursor-pointer md:w-auto md:h-auto object-contain"
              onClick={onBellClicked}
              alt="notifications"
            />
          </div>

          <Dropdown
            menu={{ items: menuItems, onClick: handleMenuClick }}
            trigger={["click"]}
            className="ms-8 cursor-pointer"
          >
            <div className="flex" style={{ borderLeft: "1px solid #E0E0E0" }}>
              <div className="ps-6 pe-4">
                <p
                  className="text-[12px] text-right font-[500] whitespace-nowrap"
                  style={{ lineHeight: "21px" }}
                >
                  {userRole === "merchant" ? merchantDisplayName : userData?.name}
                </p>
                <p className="text-[12px] text-[#8C8C8C] font-[500] whitespace-nowrap">
                  {greeting}
                </p>
              </div>

              <div className="">
                {(function () {
                  // Determine image src and whether it is the placeholder
                  const pick = () => {
                    const apiLogo = profileLogoFromApi;
                    if (apiLogo && typeof apiLogo === 'string' && apiLogo.trim() !== '') {
                      return { src: getS3PublicUrl(apiLogo), isPlaceholder: false };
                    }
                    const selLogo = getMerchantLogoValue(selectedMerchant);
                    if (userRole !== 'admin' && selLogo && typeof selLogo === 'string' && selLogo.trim() !== '') {
                      return { src: getS3PublicUrl(selLogo), isPlaceholder: false };
                    }
                    const selectedProfileLogo = Array.isArray(merchantProfiles)
                      ? getMerchantLogoValue(
                        merchantProfiles.find(
                          (profile) => getMerchantIdentity(profile) === getMerchantIdentity(selectedMerchant)
                        )
                      )
                      : undefined;
                    const listLogo = userRole === "merchant"
                      ? selectedProfileLogo
                      : selectedProfileLogo ||
                        userData?.logo || userData?.merchant?.logo || userData?.fundraiser?.logo ||
                        userData?.merchant?.logoUrl || userData?.merchant?.profileImage ||
                        userData?.merchantProfileLogo || userData?.fundraiserProfileLogo;
                    if (listLogo && typeof listLogo === 'string' && listLogo.trim() !== '') {
                      return { src: getS3PublicUrl(listLogo), isPlaceholder: false };
                    }
                    return { src: profileImagePlaceholderBlue, isPlaceholder: true };
                  };
                  const picked = pick();
                  const isAdmin = userRole === "admin";
                  const isPlaceholder = picked.isPlaceholder === true;
                  const src = isPlaceholder ? (isAdmin ? profileImagePlaceholderAdmin : profileImagePlaceholderBlue) : picked.src;
                  // Size rules:
                  // - Blue placeholder (no logo, non-admin): smaller 40/34
                  // - Real logos and admin ellipse placeholder: larger 48/44
                  const isSmallPlaceholder = isPlaceholder && !isAdmin;
                  const imgSizeClass = isSmallPlaceholder ? 'w-[32px] h-[32px]' : 'w-[40px] h-[40px]';
                  const boxSizeClass = isSmallPlaceholder ? 'w-[38px] h-[38px]' : 'w-[44px] h-[44px]';
                  return (
                    <div className={`${boxSizeClass} rounded-full flex items-center justify-center ${isSmallPlaceholder ? 'bg-[#E6F7FF] border border-[#00ADEF33]' : ''}`}>
                      <img
                        src={src}
                        alt="profile"
                        className={`${imgSizeClass} rounded-full object-cover object-top`}
                        width="40"
                        height="40"
                        decoding="async"
                        fetchPriority="high"
                      />
                    </div>
                  );
                })()}
              </div>
            </div>
          </Dropdown>
        </div>
      </div>

      {/* Main Layout Route Pages Section */}
      <div className={`px-0 md:px-5 pt-2 pb-8 relative ${isSideBarOpen ? "content-seam-shadow" : ""}`}>
        {element}

        {/* Demo notification removed */}

        {/* Backdrop for when notifications panel is open */}
        {showBackdrop && (
          <div
            className={`fixed inset-0 bg-black bg-opacity-0 z-40 transition-opacity duration-300 ${isBellClicked ? "opacity-0" : "opacity-0"
              }`}
            onClick={handleBackdropClick}
          ></div>
        )}

        {/* Always render the Notifications component but control visibility with props */}
        <Notifications isVisible={isBellClicked} onClose={() => setIsBellClicked(false)} />
      </div>
      {/* Click-catcher to close sidebar on mobile (no visual backdrop) */}
      {isSideBarOpen && (
        <div
          className="fixed inset-0 z-[900] lg:hidden"
          onClick={() => setisSideBarOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* Mobile expanding search input (overlay at top) */}
      {mobileSearchOpen && (
        <div className="sm:hidden fixed top-0 left-0 right-0 z-[950] bg-white px-4 py-3 shadow" ref={mobileSearchRef}>
          <div className="relative w-full">
            <SearchBar
              parentDivClass="w-full"
              divClassName="flex items-center w-full h-[40px] relative"
              inputClassName="navSearchBar h-full w-[100%] ps-[4%] pe-[14%] text-[14px] font-[400] outline-none bg-[#F5F5F5] text-[#303030]"
              iconClassName="absolute right-[5%] w-[22px] h-[22px]"
              placeholder="Search here"
              value={navSearchQuery}
              handleChange={handleSearchChange}
              handleKeyDown={handleNavbarSearchKeyDown}
              onBlur={handleSearchBlur}
              onClear={() => {
                setNavSearchQuery("");
                setSearchResults([]);
                setShowSearchResults(false);
              }}
              searchResults={searchResults}
              resultsVisible={showSearchResults}
              noResultsText={isSearching ? "Searching..." : "No results found"}
              handleResultClick={handleSearchResultClick}
              onIconClick={() => {
                const q = (navSearchQuery || "").trim();
                if (q.length === 0) {
                  setSearchResults([]);
                  setShowSearchResults(true);
                  return;
                }
                performSearch(q);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
